<!-- editar-estabelecimento-modal.component.html -->

<!-- Mobile: Bottom Sheet -->
@if (deviceService.$isMobile() && visible()) {
<lib-bottom-sheet
  [(visible)]="$internalVisible"
  size="full"
  [draggable]="true"
  [closeOnBackdrop]="!$loading() && !blocked()"
  [closeOnEscape]="!$loading() && !blocked()"
  [preventClose]="$loading() || blocked()"
  [headerTemplate]="headerTemplate"
  [footerTemplate]="footerTemplate"
  (hide)="fecharModal()"
>
  <ng-container *ngTemplateOutlet="conteudo"></ng-container>
</lib-bottom-sheet>
} @else {
<!-- Desktop: Dialog -->
<p-dialog
  [(visible)]="$internalVisible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [style]="{ width: '80vw', 'max-width': '80vw' }"
  styleClass="n-modal-estabelecimento"
  (onHide)="fecharModal()"
>
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
  </ng-template>

  <ng-container *ngTemplateOutlet="conteudo"></ng-container>

  <ng-template pTemplate="footer">
    <div class="n-modal-footer">
      <p-button
        [label]="'GLOBAL.CANCELAR' | translate"
        severity="secondary"
        (onClick)="fecharModal()"
        [disabled]="$loading() || blocked()"
      />
      <p-button
        [label]="'BARDO_ESTABELECIMENTOS.MODAL.SALVAR_ALTERACOES' | translate"
        icon="pi pi-check"
        (onClick)="salvar()"
        [loading]="$loading()"
        [disabled]="$salvarDesabilitado()"
      />
    </div>
  </ng-template>
</p-dialog>
}

<!-- Template de conteúdo compartilhado -->
<ng-template #conteudo>
  <div class="n-modal-content">
    <section class="n-image-upload-section">
      <h4 class="n-section-title">
        <i class="pi pi-images"></i>
        {{ 'BARDO_ESTABELECIMENTOS.MODAL.IDENTIDADE_VISUAL' | translate }}
      </h4>

      <div class="n-images-grid">
        <!-- Foto de Perfil -->
        <div
          class="n-image-upload-card"
          [class.n-uploading]="uploadingPerfil()"
          [class.n-drag-active]="dragActivePerfil()"
          [class.n-error]="errorPerfil() || $erroImagemPerfil()"
          [class.n-success]="successPerfil()"
          [class.n-disabled]="$loading() || blocked()"
          (dragover)="onDragOver($event, 'perfil')"
          (dragleave)="onDragLeave($event, 'perfil')"
          (drop)="onDrop($event, 'perfil')"
        >
          <div class="n-image-label">
            <i class="pi pi-user"></i>
            {{ 'BARDO_ESTABELECIMENTOS.MODAL.IMAGEM_LOGO' | translate }}
          </div>

          @if (previewPerfil) {
          <div
            class="n-image-preview n-profile-preview"
            role="button"
            [attr.tabindex]="$loading() || blocked() ? -1 : 0"
            [attr.aria-disabled]="$loading() || blocked() ? 'true' : 'false'"
            (click)="$loading() || blocked() ? null : selectImage('perfil')"
            (keydown.enter)="
              $loading() || blocked() ? null : selectImage('perfil')
            "
            (keydown.space)="
              $event.preventDefault();
              $loading() || blocked() ? null : selectImage('perfil')
            "
          >
            <img
              [src]="previewPerfil"
              [alt]="'BARDO_ESTABELECIMENTOS.MODAL.IMAGEM_LOGO' | translate"
            />
            <div class="n-image-overlay">
              <button
                type="button"
                pButton
                icon="pi pi-upload"
                [disabled]="$loading() || blocked()"
                (click)="
                  $event.stopPropagation();
                  $loading() || blocked() ? null : selectImage('perfil')
                "
              >
                {{ 'GLOBAL.TROCAR' | translate }}
              </button>
              <button
                type="button"
                pButton
                icon="pi pi-trash"
                severity="danger"
                [disabled]="$loading() || blocked()"
                (click)="
                  $event.stopPropagation();
                  $loading() || blocked() ? null : removeImage('perfil')
                "
              >
                {{ 'GLOBAL.REMOVER' | translate }}
              </button>
            </div>
          </div>
          } @else {
          <div
            class="n-drag-zone"
            role="button"
            [attr.tabindex]="$loading() || blocked() ? -1 : 0"
            [attr.aria-disabled]="$loading() || blocked() ? 'true' : 'false'"
            (click)="$loading() || blocked() ? null : selectImage('perfil')"
            (keydown.enter)="
              $loading() || blocked() ? null : selectImage('perfil')
            "
            (keydown.space)="
              $event.preventDefault();
              $loading() || blocked() ? null : selectImage('perfil')
            "
          >
            <div class="n-empty-state">
              <i class="pi pi-cloud-upload"></i>
              <p class="n-instruction">
                {{ 'BARDO_ESTABELECIMENTOS.MODAL.DRAG_PERFIL' | translate }}
              </p>
              <span class="n-text-secondary">{{
                'BARDO_ESTABELECIMENTOS.MODAL.FORMATO_MAX_10MB' | translate
              }}</span>
              <button
                type="button"
                pButton
                icon="pi pi-upload"
                [disabled]="$loading() || blocked()"
                (click)="
                  $event.stopPropagation();
                  $loading() || blocked() ? null : selectImage('perfil')
                "
              >
                {{
                  'BARDO_ESTABELECIMENTOS.MODAL.SELECIONAR_ARQUIVO' | translate
                }}
              </button>
              <span class="n-info-text">{{
                'BARDO_ESTABELECIMENTOS.MODAL.PROPORCAO_1_1' | translate
              }}</span>
            </div>
          </div>
          } @if (uploadingPerfil()) {
          <div class="n-progress-bar">
            <div
              class="n-progress-fill"
              [style.width.%]="uploadProgressPerfil()"
            ></div>
          </div>
          } @if ($erroImagemPerfil()) {
          <p class="n-upload-error" role="alert">{{ $erroImagemPerfil() }}</p>
          }
        </div>

        <!-- Foto de Capa -->
        <div
          class="n-image-upload-card"
          [class.n-uploading]="uploadingCapa()"
          [class.n-drag-active]="dragActiveCapa()"
          [class.n-error]="errorCapa() || $erroImagemCapa()"
          [class.n-success]="successCapa()"
          [class.n-disabled]="$loading() || blocked()"
          (dragover)="onDragOver($event, 'capa')"
          (dragleave)="onDragLeave($event, 'capa')"
          (drop)="onDrop($event, 'capa')"
        >
          <div class="n-image-label">
            <i class="pi pi-image"></i>
            {{ 'BARDO_ESTABELECIMENTOS.MODAL.FOTO_CAPA' | translate }}
          </div>

          @if (previewCapa) {
          <div
            class="n-image-preview n-cover-preview"
            role="button"
            [attr.tabindex]="$loading() || blocked() ? -1 : 0"
            [attr.aria-disabled]="$loading() || blocked() ? 'true' : 'false'"
            (click)="$loading() || blocked() ? null : selectImage('capa')"
            (keydown.enter)="
              $loading() || blocked() ? null : selectImage('capa')
            "
            (keydown.space)="
              $event.preventDefault();
              $loading() || blocked() ? null : selectImage('capa')
            "
          >
            <img
              [src]="previewCapa"
              [alt]="'BARDO_ESTABELECIMENTOS.MODAL.FOTO_CAPA' | translate"
            />
            <div class="n-image-overlay">
              <button
                type="button"
                pButton
                icon="pi pi-upload"
                [disabled]="$loading() || blocked()"
                (click)="
                  $event.stopPropagation();
                  $loading() || blocked() ? null : selectImage('capa')
                "
              >
                {{ 'GLOBAL.TROCAR' | translate }}
              </button>
              <button
                type="button"
                pButton
                icon="pi pi-trash"
                severity="danger"
                [disabled]="$loading() || blocked()"
                (click)="
                  $event.stopPropagation();
                  $loading() || blocked() ? null : removeImage('capa')
                "
              >
                {{ 'GLOBAL.REMOVER' | translate }}
              </button>
            </div>
          </div>
          } @else {
          <div
            class="n-drag-zone"
            role="button"
            [attr.tabindex]="$loading() || blocked() ? -1 : 0"
            [attr.aria-disabled]="$loading() || blocked() ? 'true' : 'false'"
            (click)="$loading() || blocked() ? null : selectImage('capa')"
            (keydown.enter)="
              $loading() || blocked() ? null : selectImage('capa')
            "
            (keydown.space)="
              $event.preventDefault();
              $loading() || blocked() ? null : selectImage('capa')
            "
          >
            <div class="n-empty-state">
              <i class="pi pi-images"></i>
              <p class="n-instruction">
                {{ 'BARDO_ESTABELECIMENTOS.MODAL.DRAG_CAPA' | translate }}
              </p>
              <span class="n-text-secondary">{{
                'BARDO_ESTABELECIMENTOS.MODAL.FORMATO_MAX_10MB' | translate
              }}</span>
              <button
                type="button"
                pButton
                icon="pi pi-upload"
                [disabled]="$loading() || blocked()"
                (click)="
                  $event.stopPropagation();
                  $loading() || blocked() ? null : selectImage('capa')
                "
              >
                {{
                  'BARDO_ESTABELECIMENTOS.MODAL.SELECIONAR_ARQUIVO' | translate
                }}
              </button>
              <span class="n-info-text">{{
                'BARDO_ESTABELECIMENTOS.MODAL.TAMANHO_IDEAL_CAPA' | translate
              }}</span>
            </div>
          </div>
          } @if (uploadingCapa()) {
          <div class="n-progress-bar">
            <div
              class="n-progress-fill"
              [style.width.%]="uploadProgressCapa()"
            ></div>
          </div>
          } @if ($erroImagemCapa()) {
          <p class="n-upload-error" role="alert">{{ $erroImagemCapa() }}</p>
          }
        </div>
      </div>
    </section>

    <form [formGroup]="$form" class="n-form">
      <div class="n-form-section">
        <h4 class="n-section-title">
          <i class="pi pi-id-card"></i>
          {{ 'BARDO_ESTABELECIMENTOS.MODAL.DADOS' | translate }}
        </h4>

        <div class="grid">
          <div class="lg:col-4 md:col-6 sm:col-6">
            <lib-form-field
              [label]="
                'BARDO_ESTABELECIMENTOS.MODAL.NOME_ESTABELECIMENTO' | translate
              "
              controlName="nome"
              [required]="true"
            >
              <input
                pInputText
                formControlName="nome"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.DIGITE_NOME' | translate
                "
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-4 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'BARDO_ESTABELECIMENTOS.MODAL.NICHO_ATUACAO' | translate"
              controlName="nicho"
              [required]="true"
            >
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                [multiple]="false"
                formControlName="nicho"
                [options]="nichos"
                optionLabel="label"
                optionValue="value"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.SELECIONE_NICHO' | translate
                "
              />
              } @else {
              <p-select
                formControlName="nicho"
                [options]="nichos"
                optionLabel="label"
                optionValue="value"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.SELECIONE_NICHO' | translate
                "
                styleClass="w-full"
                [appendTo]="$dropdownAppendTo()"
              />
              }
            </lib-form-field>
          </div>

          <div class="lg:col-4 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'GLOBAL.TELEFONE' | translate"
              controlName="telefone"
              [required]="true"
            >
              <lib-phone-input
                [value]="$form.get('telefone')?.value ?? ''"
                (valueChange)="onTelefoneChange($event)"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-6 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'BARDO_ESTABELECIMENTOS.MODAL.REDE_SOCIAL' | translate"
              controlName="redeSocial"
            >
              <input
                pInputText
                formControlName="redeSocial"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.REDE_SOCIAL_PLACEHOLDER'
                    | translate
                "
                class="w-full"
              />
            </lib-form-field>
          </div>
          <div class="lg:col-6 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'BARDO_ESTABELECIMENTOS.MODAL.WEBSITE' | translate"
              controlName="website"
            >
              <input
                pInputText
                formControlName="website"
                placeholder="https://..."
                class="w-full"
              />
            </lib-form-field>
          </div>
        </div>
      </div>

      <div class="n-form-section">
        <h4 class="n-section-title">
          <i class="pi pi-cog"></i>
          {{ 'BARDO_ESTABELECIMENTOS.MODAL.CONFIGURACOES' | translate }}
        </h4>

        <div class="grid">
          <div class="lg:col-3 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'BARDO_ESTABELECIMENTOS.MODAL.HORA_ABERTURA' | translate"
              controlName="horaAbertura"
              [required]="true"
            >
              <p-datepicker
                formControlName="horaAbertura"
                [timeOnly]="true"
                hourFormat="24"
                [showSeconds]="false"
                dateFormat="HH:mm"
                placeholder="08:00"
                styleClass="w-full"
                [appendTo]="$dropdownAppendTo()"
                [class.ng-invalid]="horariosInvalidos"
                [class.ng-dirty]="horariosInvalidos"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-3 md:col-6 sm:col-6">
            <lib-form-field
              [label]="
                'BARDO_ESTABELECIMENTOS.MODAL.HORA_FECHAMENTO' | translate
              "
              controlName="horaFechamento"
              [required]="true"
            >
              <p-datepicker
                formControlName="horaFechamento"
                [timeOnly]="true"
                hourFormat="24"
                [showSeconds]="false"
                dateFormat="HH:mm"
                placeholder="18:00"
                styleClass="w-full"
                [appendTo]="$dropdownAppendTo()"
                [class.ng-invalid]="horariosInvalidos"
                [class.ng-dirty]="horariosInvalidos"
              />
            </lib-form-field>
          </div>
          <div class="lg:col-3 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'BARDO_ESTABELECIMENTOS.MODAL.ABRE_FERIADOS' | translate"
              controlName="abreFeriado"
            >
              <p-selectbutton
                formControlName="abreFeriado"
                [options]="btnAbreFeriado"
                optionLabel="label"
                optionValue="value"
                [allowEmpty]="false"
              />
            </lib-form-field>
          </div>
          <div class="lg:col-3 md:col-6 sm:col-6">
            <lib-form-field
              [label]="
                'BARDO_ESTABELECIMENTOS.MODAL.DIAS_FUNCIONAMENTO' | translate
              "
              controlName="diasFuncionamento"
              [required]="true"
            >
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                formControlName="diasFuncionamento"
                [options]="diasSemana"
                optionLabel="nome"
                optionValue="id"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.SELECIONE_DIAS' | translate
                "
                [showHeader]="false"
              />
              } @else {
              <p-multiselect
                formControlName="diasFuncionamento"
                [options]="diasSemana"
                optionLabel="nome"
                optionValue="id"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.SELECIONE_DIAS' | translate
                "
                [filter]="false"
                display="chip"
                styleClass="w-full"
                [appendTo]="$dropdownAppendTo()"
              />
              }
            </lib-form-field>
          </div>
          <div class="lg:col-6 md:col-12 sm:col-12">
            <lib-form-field
              [label]="
                'BARDO_ESTABELECIMENTOS.MODAL.SELECAO_CLIENTE_WHATSAPP'
                  | translate : { termo: $nicho().cliente.singular }
              "
              controlName="habilitarSelecaoPaciente"
            >
              <p-selectbutton
                formControlName="habilitarSelecaoPaciente"
                [options]="btnAbreFeriado"
                optionLabel="label"
                optionValue="value"
                [allowEmpty]="false"
              />
            </lib-form-field>
            <small class="n-field-hint">
              {{
                'BARDO_ESTABELECIMENTOS.MODAL.SELECAO_CLIENTE_HINT'
                  | translate
                    : { termo: $nicho().cliente.singular.toLowerCase() }
              }}
            </small>
          </div>
        </div>
      </div>

      <!-- Endereço -->
      <div class="n-form-section" formGroupName="endereco">
        <h4 class="n-section-title">
          <i class="pi pi-map-marker"></i>
          {{ 'BARDO_ESTABELECIMENTOS.MODAL.ENDERECO' | translate }}
        </h4>

        <div class="grid">
          <div class="lg:col-4 md:col-6 sm:col-12">
            <lib-form-field [label]="'ACOES.PAIS' | translate" controlName="pais" [required]="true">
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                [multiple]="false"
                formControlName="pais"
                [options]="paises"
                optionLabel="nome"
                optionValue="codigo"
                [placeholder]="'BARDO_ESTABELECIMENTOS.MODAL.SELECIONE_PAIS' | translate"
                (selectionChange)="aoSelecionarPais($event.value)"
              />
              } @else {
              <p-select
                formControlName="pais"
                [options]="paises"
                optionLabel="nome"
                optionValue="codigo"
                [placeholder]="'BARDO_ESTABELECIMENTOS.MODAL.SELECIONE_PAIS' | translate"
                [filter]="true"
                filterBy="nome"
                [emptyMessage]="'BARDO_ESTABELECIMENTOS.MODAL.NENHUM_PAIS_ENCONTRADO' | translate"
                [emptyFilterMessage]="'BARDO_ESTABELECIMENTOS.MODAL.NENHUM_PAIS_ENCONTRADO' | translate"
                [appendTo]="$dropdownAppendTo()"
                styleClass="w-full"
                (onChange)="aoSelecionarPais($event.value)"
              />
              }
            </lib-form-field>
          </div>
        </div>

        <div class="grid">
          @if (ehEnderecoBrasil()) {
          <div class="lg:col-2 md:col-3 sm:col-6">
            <lib-form-field
              [label]="'GLOBAL.CEP' | translate"
              controlName="codPostal"
              [required]="true"
            >
              <p-inputMask
                formControlName="codPostal"
                mask="99999-999"
                placeholder="00000-000"
                styleClass="w-full"
              />
            </lib-form-field>
          </div>
          <div class="lg:col-2 md:col-4">
            <lib-form-field
              [label]="'GLOBAL.ESTADO' | translate"
              controlName="estado"
              [required]="true"
            >
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                [multiple]="false"
                formControlName="estado"
                [options]="estados"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.SELECIONE_ESTADO' | translate
                "
              />
              } @else {
              <p-select
                formControlName="estado"
                [options]="estados"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.SELECIONE_ESTADO' | translate
                "
                [filter]="true"
                [emptyMessage]="'GLOBAL.NENHUM_RESULTADO' | translate"
                [appendTo]="$dropdownAppendTo()"
                scrollHeight="80px"
                styleClass="w-full"
              />
              }
            </lib-form-field>
          </div>

          <div class="lg:col-6 md:col-5 sm:col-6">
            <lib-form-field
              [label]="'GLOBAL.LOGRADOURO' | translate"
              controlName="logradouro"
              [required]="true"
            >
              <input
                pInputText
                formControlName="logradouro"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.LOGRADOURO_PLACEHOLDER'
                    | translate
                "
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-2 md:col-3 sm:col-6">
            <lib-form-field
              [label]="'GLOBAL.NUMERO' | translate"
              controlName="numero"
              [required]="true"
            >
              <input
                pInputText
                formControlName="numero"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.NUMERO_PLACEHOLDER' | translate
                "
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-4 md:col-9 sm:col-6">
            <lib-form-field
              [label]="'GLOBAL.COMPLEMENTO' | translate"
              controlName="complemento"
            >
              <input
                pInputText
                formControlName="complemento"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.COMPLEMENTO_PLACEHOLDER'
                    | translate
                "
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-4 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'GLOBAL.BAIRRO' | translate"
              controlName="bairro"
              [required]="true"
            >
              <input
                pInputText
                formControlName="bairro"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.DIGITE_BAIRRO' | translate
                "
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-4 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'GLOBAL.CIDADE' | translate"
              controlName="cidade"
              [required]="true"
            >
              <input
                pInputText
                formControlName="cidade"
                [placeholder]="
                  'BARDO_ESTABELECIMENTOS.MODAL.DIGITE_CIDADE' | translate
                "
                class="w-full"
              />
            </lib-form-field>
          </div>
          } @else {
          <div class="lg:col-8 md:col-8 sm:col-12">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.LABEL_ADDRESS_LINE' | translate"
              controlName="logradouro"
              [required]="true"
            >
              <input
                pInputText
                formControlName="logradouro"
                [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_ADDRESS_LINE' | translate"
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-4 md:col-4 sm:col-6">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.LABEL_ADDRESS_NUMBER' | translate"
              controlName="numero"
              [required]="true"
            >
              <input
                pInputText
                formControlName="numero"
                placeholder="12"
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-4 md:col-6 sm:col-6">
            <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_CITY' | translate" controlName="cidade" [required]="true">
              <input
                pInputText
                formControlName="cidade"
                [placeholder]="'PRIMEIRO_ACESSO.LABEL_CITY' | translate"
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-4 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.LABEL_REGION' | translate"
              controlName="estado"
              [required]="true"
            >
              <input
                pInputText
                formControlName="estado"
                [placeholder]="'PRIMEIRO_ACESSO.LABEL_REGION' | translate"
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="lg:col-4 md:col-6 sm:col-6">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.LABEL_POSTAL_CODE' | translate"
              controlName="codPostal"
              [required]="true"
            >
              <input
                pInputText
                formControlName="codPostal"
                [placeholder]="'PRIMEIRO_ACESSO.LABEL_POSTAL_CODE' | translate"
                maxlength="20"
                class="w-full"
              />
            </lib-form-field>
          </div>
          }
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!-- Templates compartilhados para Header e Footer -->
<ng-template #headerTemplate>
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12 n-header-gradient"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-header-title text-white font-bold">
            <i class="pi pi-building mr-2"></i>
            {{ 'BARDO_ESTABELECIMENTOS.MODAL.TITULO' | translate }}
          </span>
        </div>
        <div class="sm:col-12 md:col-4 flex justify-content-end gap-2">
          @if (!deviceService.$isMobile()) {
          <button
            type="button"
            class="n-close-btn"
            (click)="fecharModal()"
            [disabled]="$loading() || blocked()"
            [attr.aria-label]="'GLOBAL.FECHAR' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="w-full">
    <p-button
      [label]="'BARDO_ESTABELECIMENTOS.MODAL.SALVAR_ALTERACOES' | translate"
      styleClass="w-full"
      icon="pi pi-check"
      (onClick)="salvar()"
      [loading]="$loading()"
      [disabled]="$salvarDesabilitado()"
    />
  </div>
</ng-template>

<!-- Inputs fora do ng-template: no mobile a referência do arquivo invalida se o DOM for recriado -->
<input
  #fileInputPerfil
  type="file"
  accept="image/*"
  (change)="onFileSelect('perfil', $event)"
  hidden
/>
<input
  #fileInputCapa
  type="file"
  accept="image/*"
  (change)="onFileSelect('capa', $event)"
  hidden
/>
